export default function Footer() {
  const navLinks = ['Início', 'Imóveis', 'Venda', 'Locação', 'Avaliação', 'Quem Somos', 'Contato'];
  const cities = ['Chapecó', 'Xanxerê', 'São Miguel do Oeste', 'Maravilha', 'Palmitos', 'E muito mais!'];

  return (
    <footer id="contato" className="bg-secondary-900 text-background-300">
      {/* Main footer */}
      <div className="px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Logo & Social */}
          <div className="footer-brand-column">
            <a href="#inicio" className="footer-logo-link">
              <img
                src="/logo-rodape-v3.png"
                alt="Bertoncello Negócios Imobiliários BNI"
                className="footer-logo-image"
              />
            </a>
            <p className="text-xs text-background-500 leading-relaxed mb-4">
              Conectando você ao melhor do Oeste Catarinense.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 text-background-400 hover:text-primary-400 hover:bg-secondary-700 transition-colors" aria-label="Facebook">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 text-background-400 hover:text-primary-400 hover:bg-secondary-700 transition-colors" aria-label="Instagram">
                <i className="ri-instagram-line"></i>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-background-50 text-xs font-bold uppercase tracking-wider mb-4">
              Navegação
            </h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link}>
                  <a
                    href="#"
                    className="text-xs text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Cities */}
          <div>
            <h4 className="text-background-50 text-xs font-bold uppercase tracking-wider mb-4">
              Cidades de Atuação
            </h4>
            <ul className="space-y-2">
              {cities.map((city) => (
                <li key={city}>
                  <span className="text-xs text-background-400">{city}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-background-50 text-xs font-bold uppercase tracking-wider mb-4">
              Contato
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-500 mt-0.5">
                  <i className="ri-phone-line text-xs"></i>
                </span>
                <a href="tel:+554991950002" className="text-xs text-background-400 hover:text-primary-400">(49) 9 9195-0002</a>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-500 mt-0.5">
                  <i className="ri-mail-line text-xs"></i>
                </span>
                <a href="mailto:mauricio@grupobni.com.br" className="text-xs text-background-400 hover:text-primary-400">mauricio@grupobni.com.br</a>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-500 mt-0.5">
                  <i className="ri-map-pin-line text-xs"></i>
                </span>
                <span className="text-xs text-background-400 leading-relaxed">
                  Rua Mondaí, 97<br />
                  Bairro Engenho Braun<br />
                  Chapecó/SC
                </span>
              </li>
            </ul>
            <div className="mt-6 border-t border-secondary-800 pt-5">
              <img
                src="/ssl-certificado-transparente.png"
                alt="Site seguro com certificado SSL"
                className="h-auto w-48 max-w-full object-contain"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-secondary-800">
        <div className="px-4 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-[11px] text-background-600">
            &copy; 2024 Bertoncello Negócios Imobiliários BNI. Todos os direitos reservados.
          </p>
          <p className="text-[11px] text-background-600">
            Orgulhosamente desenvolvido por{' '}
            <a href="#" className="text-primary-400 hover:text-primary-300 transition-colors">
              Serra Consultoria
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
